import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-my-tasks',
  templateUrl: './my-tasks.component.html',
  styleUrls: ['./my-tasks.component.css']
})
export class MyTasksComponent implements OnInit {

  usersList: any= []
  status = ""
  userId = ""
  date1: any
  date2: any
  filteredData: any= []
  startDate=""
  endDate = ""

  NEW_tasksCount = 0
  ASSIGNED_tasksCount = 0
  REASSIGNED_tasksCount = 0
  WORK_IN_PROGRESS_tasksCount = 0
  PENDING_tasksCount = 0
  COMPLETED_tasksCount = 0
  DEFERRED_tasksCount = 0
  PARTIALLY_COMPLETED_tasksCount = 0
  FORCE_CLOSED_tasksCount = 0
  CLOSED_tasksCount = 0
  Total_tasksCount = 0
  inCompletedTask = []
  completedTask = []
  option = ""

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.option = 'WORK_IN_PROGRESS'
    this.getUsers()
    this.getUserActiveTask()
    this.getUserNonActiveTask()
    let userId = sessionStorage.getItem('userId')
    // startDate = formatDate(this.submitForm2.get('startDate').value, 'dd/MM/yyyy', 'en-US')

    // var d = new Date();
    // d.setDate(d.getDate()-5);
   this.date2 = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')
   console.log(new Date(this.date2).getTime())
   this.date1 = new Date()
   this.date1.setDate(this.date1.getDate()-90);
   this.date1 = formatDate(this.date1, 'yyyy-MM-dd', 'en-US')
   let startDate = new Date(this.date1).getTime()
   let endDate = new Date(this.date2).getTime()
   this.taskFilterByAndUserIdAndDates(this.pageNumber,this.recordsPerPage,userId, startDate, endDate)

   this.getStatus()
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.filterByAssignedToBetweenDates();
  }

  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
      }
    )
  }

  taskFilterByAndUserIdAndDates(pageNumber:any,recordsPerPage:any,userId:any,startDate:any,endDate:any){
    this.isLoading = true;

    this.generic_service.taskFilterByAndUserIdAndDates(pageNumber,recordsPerPage,userId,startDate,endDate).subscribe(
      (response:any)=>{
        console.log(response)
        this.filteredData = []
        this.filteredData = response.response.taskList;
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false;
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  filterByAssignedToBetweenDates(){
    let userId = sessionStorage.getItem('userId')
    let startDate = new Date(this.date1).getTime()
    let endDate = new Date(this.date2).getTime()
    this.taskFilterByAndUserIdAndDates(this.pageNumber,this.recordsPerPage,userId,startDate,endDate)
  }

  getTasksByStatus(status:any){
    // this.taskType = status;
    // this.addClassType = '';
    console.log(status)
    // this.generic_service.getTasksByStatus(status).subscribe(
    //   (res:any)=>{
    //     console.log(res)
    //     this.filteredData = res.response
    //   },
    //   (err:any)=>{
    //     console.log(err)
    //   }
    // )
  }

  getUserActiveTask() {
    this.generic_service.getUserActiveTask(sessionStorage.getItem('userId')).subscribe((res: any) => {
      console.log(res)
      this.inCompletedTask = res.response
    })
  }

  getUserNonActiveTask() {
    this.generic_service.getUserNonActiveTask(sessionStorage.getItem('userId')).subscribe((res: any) => {
      console.log(res)
      this.completedTask = res.response
    })
  }

  getDataByStatus(status: any){
    this.option = status;
    console.log(this.option)
    this.getStatus()
  }

  getStatus() {
    if (this.option === "WORK_IN_PROGRESS"){
      this.filteredData = this.inCompletedTask
    }else{
      this.filteredData = this.completedTask
    }
    console.log(this.filteredData)
  }
}
